import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";

const Sidebar = ({ user, isOpen, onToggle }) => {
  const location = useLocation();
  const { logout } = useAuth();
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      toast.error("Logout gagal. Silakan coba lagi.");
    }
  };

  const getMenuItems = () => {
    const baseMenu = [
      {
        path: "/dashboard",
        icon: "fas fa-tachometer-alt",
        label: "Beranda",
        roles: ["admin", "pengguna", "peninjau"],
      },
      {
        icon: "fas fa-building",
        label: "Bangunan",
        roles: ["admin", "pengguna"],
        children: [
          {
            path: "/housing",
            icon: "fas fa-layer-group",
            label: "Data",
            roles: ["admin", "pengguna"],
          },
          {
            path: "/scoring",
            icon: "fa-solid fa-arrow-up-1-9",
            label: "Penilaian",
            roles: ["admin"],
          },
        ],
      },
      {
        icon: "fas fa-map",
        label: "Peta",
        roles: ["admin", "pengguna"],
        children: [
          {
            path: "/map",
            icon: "fas fa-map-marker-alt",
            label: "Lokasi Bangunan",
            roles: ["admin", "pengguna", "peninjau"],
          },
          {
            path: "/map/rtlh",
            icon: "fas fa-location",
            label: "Lokasi Proyeksi RTLH",
            roles: ["admin", "pengguna", "peninjau"],
          },
        ],
      },
      {
        path: "/reports",
        icon: "fas fa-chart-bar",
        label: "Laporan & Ringkasan",
        roles: ["admin", "peninjau"],
      },
    ];

    // Add admin-only menu items
    if (user?.role === "admin") {
      baseMenu.push({
        icon: "fas fa-user",
        label: "Admin",
        roles: ["admin", "pengguna"],
        children: [
          {
            path: "/users",
            icon: "fas fa-users",
            label: "Manajemen Pengguna",
            roles: ["admin"],
          },
          {
            path: "/databases",
            icon: "fas fa-database",
            label: "Manajemen BasisData",
            roles: ["admin"],
          },
          // {
          //   path: '/questionary',
          //   icon: 'fas fa-thumbtack',
          //   label: 'Questionary',
          //   roles: ['admin']
          // },
          {
            path: "/questions",
            icon: "fas fa-thumbtack",
            label: "Questions",
            roles: ["admin"],
          },
        ],
      });
    }

    return baseMenu.filter((item) => item.roles.includes(user?.role));
  };

  const menuItems = getMenuItems();

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="d-md-none position-fixed w-100 h-100 bg-dark opacity-50"
          style={{ top: 0, left: 0, zIndex: 499 }}
          onClick={onToggle}
        />
      )}

      {/* Sidebar */}
      <nav className={`sidebar ${isOpen ? "show" : ""}`}>
        <div className="sidebar-header p-3">
          <h6 className="mb-0 text-primary">
            <i className="fas fa-cogs me-2"></i>
            Menu Navigasi
          </h6>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              {item.children ? (
                <>
                  <div
                    className={`d-flex align-items-center item-header`}
                    onClick={() =>
                      setOpenMenu(openMenu === item.label ? null : item.label)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center">
                      <i className={`${item.icon} me-3`}></i>
                      <span className="me-2">{item.label}</span>
                    </div>
                    <i
                      className={`fas fa-chevron-${
                        openMenu === item.label ? "down" : "right"
                      }`}
                    ></i>
                  </div>
                  {openMenu === item.label && (
                    <ul className="list-unstyled ms-4 mt-2">
                      {item.children.map((child, i) => (
                        <li key={i}>
                          <Link
                            to={child.path}
                            className={`d-flex align-items-center ${
                              isActive(child.path) ? "active" : ""
                            }`}
                            onClick={() => {
                              if (window.innerWidth < 768) {
                                onToggle();
                              }
                            }}
                          >
                            <i className={`${child.icon} me-2`}></i>
                            <span>{child.label}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`d-flex align-items-center ${
                    isActive(item.path) ? "active" : ""
                  }`}
                  onClick={() => {
                    // Close sidebar on mobile when item is clicked
                    if (window.innerWidth < 768) {
                      onToggle();
                    }
                  }}
                >
                  <i className={`${item.icon} me-3`}></i>
                  <span>{item.label}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
        <div className="sidebar-footer p-3 mt-auto">
          <div className="text-muted small">
            <div className="mb-1">
              <strong>User:</strong> {user?.full_name}
            </div>
            <div>
              <strong>Role:</strong> {user?.role}
            </div>
          </div>
        </div>
        <div className="px-3">
          <button className="dropdown-item text-danger" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt me-2"></i>
            Logout
          </button>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
